import { useContext, useEffect, useRef, useState } from "react";
import { toast } from "react-toastify";
import CustomButton from "../../Components/Base/CustomButton";
import InputTextBox from "../../Components/Base/InputTextBox";
import Loader from "../../Components/Loder";
import ToolBar from "../../Components/ToolBar/ToolBar";
import AppContext from "../../Context/AppContext";
import { RestReportBean } from "../../Ds/client_ds";
import PageBar from "../../Components/ToolBar/PageBar";
import {
  InvoiceRegisterPrintRequest,
  LogisticOrderSearchCriteria,
  RestPrintInputRequest,
  RestLogisticOrderListRequest,
  PageListBean,
  RestEntityPrintRequest,
  RestReadRequest,
} from "../../Ds/ds";
import service from "../../Services/Service";
import ReactTable from "../../Components/Table";
import {
  TOAST_ERROR,
  TOAST_SUCESS,
  TOAST_WARN,
} from "../../Utils/appConstants";
import {
  ColumnDefinition,
  isEmpty,
  isEmptyArray,
  isEmptyString,
  StatusConvertor,
  toCommaSeperatedAmount,
} from "../../Utils/util";
import InValidAccess from "../../Components/InValidAccess";
import { SecurityAccessManager } from "../../Security/SecurityAccessManager";
import { EXCELICON, MOREOPTIONICON, PDFICON } from "../../Utils/icons";
import Modal from "../../Components/Modal";
import CustomTable from "../../Components/Base/CustomTable";
import ViewToggle from "../../Components/ViewToggle";

const OrderDetails = ({ orderData }) => {
  // const tableColumns = [
  //   {
  //     header: "SKU",
  //     accessor: "rollSkuNumber",
  //     sortable: true,
  //     // isHyperLink: true,
  //     // clickHandler: click_Handler,
  //   },
  //   {
  //     header: "YD",
  //     accessor: "onHandQuantity",
  //     sortable: true,
  //     alignment: "left",
  //   },
  //   { header: "BIN", accessor: "aisleInfoText", sortable: true },
  // ];
  const Columns = () => {
    const _columns = new Array();

    _columns.push(
      new ColumnDefinition()
        .setDetails("Item", "fabricStyleCode", true)
        .setStyleDetails("left", "7", "", "wt-5", "")
    );
    _columns.push(
      new ColumnDefinition()
        .setDetails("Name", "fabricStyleName", true)
        .setStyleDetails("left", "7", "", "wt-5", "")
    );
    _columns.push(
      new ColumnDefinition()
        .setDetails("Color", "colorCode", true)
        .setStyleDetails("left", "4", "", "wt-5", "")
    );
    _columns.push(
      new ColumnDefinition()
        .setDetails("InvUOM", "inventoryUomCode", true)
        .setStyleDetails("left", "3", "", "wt-3", "wt-3")
    );
    _columns.push(
      new ColumnDefinition()
        .setDetails("UOM", "uomCode", true)
        .setStyleDetails("left", "3", "", "wt-3", "wt-3")
    );
    _columns.push(
      new ColumnDefinition()
        .setDetails("OrderQty", "orderQuantity", true, true)
        .setStyleDetails("right", "3", "", "wt-3", "wt-3")
    );
    _columns.push(
      new ColumnDefinition()
        .setDetails("RcdQty", "receivedQuantity", true, true)
        .setStyleDetails("right", "3", "", "wt-3", "wt-3")
    );
    _columns.push(
      new ColumnDefinition()
        .setDetails("OpenQty", "openQuantity", true, true)
        .setStyleDetails("right", "3", "", "wt-3", "wt-3")
    );
    _columns.push(
      new ColumnDefinition()
        .setDetails("Location", "locationCode", true)
        .setStyleDetails("left", "3", "", "wt-3", "wt-3")
    );
    _columns.push(
      new ColumnDefinition()
        .setDetails("Status", "lineStatus", true)
        .setStyleDetails("left", "2", "", "wt-3", "wt-3")
    );
    return _columns;
  };

  const invLines = new Array();
  return (
    <div className="model-fw">
      {/* <ReactTable data={orderData.lines} columns={Columns} /> */}
      <CustomTable
        columns={Columns}
        data={orderData.lines}
        isShowFullScreen={true}
      />
    </div>
  );
};

export default function InBoundOrdersInquiry() {
  const { token, setisSessionExpeired, session } = useContext(AppContext);
  const [dataList, setDataList] = useState([]);
  const [criteria, setCriteria] = useState(new LogisticOrderSearchCriteria());
  const title = "Inound Orders";
  const [customerCode, setCustomerCode] = useState("");
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(50);
  const [maxPage, setMaxPage] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [isShowPdf, setIsShowPdf] = useState(false);
  const [isShowExcel, setIsShowExcel] = useState(false);
  const [disable, setDisable] = useState(false);
  const [isAccessible, setIsAccessible] = useState(false);
  const inputRef = useRef(null);
  const buttonRef = useRef(null);
  const [isShowModal, setIsShowModal] = useState(false);

  const [orderData, setOrderData] = useState({});

  const [view, setView] = useState(window.innerWidth <= 768 ? 1 : 2);
  useEffect(() => {
    function handleResize() {
      setView(getDefaultView());
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  function getDefaultView() {
    return window.innerWidth <= 768 ? 1 : 2;
  }

  const listViewHandler = () => {
    setView(1);
  };
  const gridViewHandler = () => {
    setView(2);
  };

  const setFocus = () => {
    if (inputRef.current != null) inputRef.current.focus();
  };

  const handleOrderDetailsResponse = (response) => {
    let msg = "";
    let msg_List = new Array();
    if (!isEmpty(response.data)) {
      if (response.data.isSessionExpired) {
        setisSessionExpeired(true);
      } else if (response.data.isSuccess) {
        if (!isEmpty(response.data.logisticOrder)) {
          setOrderData(response.data.logisticOrder);
          setIsShowModal(true);
        }
        if (!isEmptyArray(response.data.infos)) {
          response.data.infos.map((info) => {
            msg_List.push(info.messageDescription);
          });
          msg = msg_List.toString();
          notify(TOAST_SUCESS, msg);
        }
      } else {
        if (!isEmptyArray(response.data.errors)) {
          response.data.errors.map((error) => {
            msg_List.push(error.messageDescription);
          });
          msg = msg_List.toString();
          notify(TOAST_ERROR, msg);
        }
      }
    }
    setIsLoading(false);
  };

  const openModal = (code) => {
    getOrderDetails(code);
  };

  const getOrderDetails = (code) => {
    setIsLoading(true);
    const request = new RestReadRequest();
    request.companyCode = process.env.REACT_APP_COMPANY;
    request.code = code;
    const path = "readLogisticOrder";
    service(token, path, request, handleOrderDetailsResponse, errorCallBack);
  };

  const closeModal = () => {
    setIsShowModal(false);
  };

  const asignDefault = () => {
    const _criteria = new LogisticOrderSearchCriteria();
    _criteria.companyCode = process.env.REACT_APP_COMPANY;
    const _customers = new Array();
    if (!isEmpty(session)) {
      const { entityCode, code } = session;
      if (!isEmptyString(entityCode)) {
        _criteria.customerCode = entityCode;
        setCustomerCode(entityCode);
      }
    }
    setCriteria(_criteria);
  };

  useEffect(() => {
    setFocus();
    asignDefault();
  }, []);

  const notify = (type, msg, theme) => {
    if (type === 1)
      toast.info(msg, {
        theme: theme,
      });
    else if (type === 2)
      toast.error(msg, {
        theme: theme,
      });
    else if (type === 3)
      toast.success(msg, {
        theme: theme,
      });
    else if (type === 4)
      toast.warn(msg, {
        theme: theme,
      });
    else toast(msg);
  };

  const errorCallBack = (error) => {
    setIsLoading(false);
    notify(TOAST_ERROR, error.message);
  };

  const handleReportResponse = (response) => {
    let msg = "";
    let msg_List = new Array();
    if (response.data != null) {
      if (response.data.isSessionExpired) {
        setisSessionExpeired(true);
      } else if (response.data.isSuccess) {
        if (response.data.reportResult != null) {
          if (!isEmptyString(response.data.reportResult.reportFileID)) {
            let reportFilePath = response.data.reportResult.reportFileID;
            window.open(
              `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_REPORT_PATH}` +
                reportFilePath
            );
          }
        }
        if (!isEmptyArray(response.data.infos)) {
          response.data.infos.map((info) => {
            msg_List.push(info.messageDescription);
          });
          msg = msg_List.toString();
          notify(TOAST_SUCESS, msg);
        }
      } else {
        if (!isEmptyArray(response.data.errors)) {
          response.data.errors.map((error) => {
            msg_List.push(error.messageDescription);
          });
          msg = msg_List.toString();
          notify(TOAST_ERROR, msg);
        }
      }
    }
    setIsLoading(false);
  };

  const generateReport = (type, code) => {
    const request = new RestEntityPrintRequest();
    const reportBean = new RestReportBean();
    reportBean.reportType = type;
    request.companyCode = process.env.REACT_APP_COMPANY;
    request.entityCode = code;
    request.reportBean = reportBean;
    const path = "generateLogisticOrderPrintReport";
    service(token, path, request, handleReportResponse, errorCallBack);
  };

  const PDFHandler = (code) => {
    if (SecurityAccessManager.LogisticOrderPDFReport_IsAccessible()) {
      setIsLoading(true);
      generateReport(1, code);
    } else {
      setIsAccessible(true);
    }
  };

  const ExcelHandler = (code) => {
    if (SecurityAccessManager.LogisticOrderExcelReport_IsAccessible()) {
      setIsLoading(true);
      generateReport(2, code);
    } else {
      setIsAccessible(true);
    }
  };

  const MoreOptionHandler = (code) => {
    openModal(code);
  };

  const ResetHandler = () => {
    setDataList([]);
    setDisable(false);
    setIsShowExcel(false);
    setIsShowPdf(false);
    setFocus();
    asignDefault();
  };

  const handleResponse = (response) => {
    let msg = "";
    let msg_List = new Array();
    if (!isEmpty(response.data)) {
      if (response.data.isSessionExpired) {
        setisSessionExpeired(true);
      } else if (response.data.isSuccess) {
        if (
          !isEmpty(response.data.logisticOrderPageList) &&
          !isEmptyArray(response.data.logisticOrderPageList.logisticOrders)
        ) {
          setDataList(response.data.logisticOrderPageList.logisticOrders);
          if (response.data.logisticOrderPageList.totalCount != null) {
            const total_Count = response.data.logisticOrderPageList.totalCount;
            const maxPage = Math.ceil(total_Count / pageSize);
            setTotalCount(total_Count);
            // setIsShowExcel(true);
            // setIsShowPdf(true);
            setMaxPage(maxPage);
          }
          if (response.data.logisticOrderPageList.currentPage != null) {
            setPage(response.data.logisticOrderPageList.currentPage);
          }
          if (!isEmptyArray(response.data.infos)) {
            response.data.infos.map((info) => {
              msg_List.push(info.messageDescription);
            });
            msg = msg_List.toString();
            notify(TOAST_SUCESS, msg);
          }
        }
        if (
          !isEmpty(response.data.logisticOrderPageList) &&
          isEmptyArray(response.data.logisticOrderPageList.logisticOrders)
        ) {
          notify(TOAST_WARN, "No Data Found");
        }
      } else {
        if (!isEmptyArray(response.data.errors)) {
          response.data.errors.map((error) => {
            msg_List.push(error.messageDescription);
          });
          msg = msg_List.toString();
          notify(TOAST_ERROR, msg);
        }
      }
    }
    setIsLoading(false);
  };

  const ExecuteHandler = () => {
    loadPage(1);
  };

  const loadPrevious = () => {
    if (page > 1) {
      const pagenumber = parseInt(page) - 1;
      loadPage(pagenumber);
    }
  };

  const loadNext = () => {
    if (maxPage > page) {
      const pagenumber = parseInt(page) + 1;
      loadPage(pagenumber);
    }
  };

  const loadFirst = () => {
    loadPage(1);
  };

  const loadLast = () => {
    loadPage(maxPage);
  };

  const loadPage = (id) => {
    if (SecurityAccessManager.LogesticOrder_IsAccessible()) {
      setDataList([]);
      setIsLoading(true);
      const request = new RestLogisticOrderListRequest();
      request.criteria = criteria;
      const pageInput = new PageListBean();
      pageInput.currentPage = id;
      pageInput.pageSize = pageSize;
      request.pageInput = pageInput;
      const path = "getLogisticOrderPageList";
      service(token, path, request, handleResponse, errorCallBack);
    } else {
      setIsAccessible(true);
    }
  };

  const buttonHandler = (e) => {
    loadFirst();
  };

  const onClose = () => {
    setIsAccessible(false);
  };

  const Columns = () => {
    const _columns = new Array();

    _columns.push(
      new ColumnDefinition()
        .setDetails("InBoundOrder", "code", true)

        .setStyleDetails("left", "", "", "wt-4", "wt-4")
    );
    _columns.push(
      new ColumnDefinition()
        .setDetails("OrderQty", "logisticOrderTotalQuantity", true)

        .setStyleDetails("Right", "", "", "wt-4", "wt-4")
    );
    _columns.push(
      new ColumnDefinition()
        .setDetails("Status", "orderStatus", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
    );

    _columns.push(
      new ColumnDefinition()
        .setDetails("Customer", "customerCode", true)
        .setStyleDetails("left", "10", "", "wt-3", "wt-3")
    );
    _columns.push(
      new ColumnDefinition()
        .setDetails("Name", "customerName", true)
        .setStyleDetails("left", "10", "", "wt-3", "wt-3")
    );
    _columns.push(
      new ColumnDefinition()
        .setDetails("Date", "orderDate", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
    );
    _columns.push(
      new ColumnDefinition()
        .setDetails("", "code", true)
        .setStyleDetails("right", "", "", "wt-3", "wt-3")
        .setClickDetails(false, true, PDFHandler, <PDFICON />)
    );
    _columns.push(
      new ColumnDefinition()
        .setDetails("", "code", true)
        .setStyleDetails("right", "", "", "wt-3", "wt-3")
        .setClickDetails(false, true, ExcelHandler, <EXCELICON />)
    );
    _columns.push(
      new ColumnDefinition()
        .setDetails("", "code", true)
        .setStyleDetails("right", "", "", "wt-3", "wt-3")
        .setClickDetails(false, true, MoreOptionHandler, <MOREOPTIONICON />)
    );

    return _columns;
  };

  return (
    <>
      {isLoading ? <Loader /> : null}
      <Modal
        isOpen={isShowModal}
        onClose={closeModal}
        title={"Inbound Order Lines"}
      >
        <OrderDetails orderData={orderData} />
      </Modal>
      <ToolBar
        title={title}
        ResetHandler={ResetHandler}
        ExecuteHandler={ExecuteHandler}
        isShowPdf={isShowPdf}
        isShowExcel={isShowExcel}
      />
      <div className="card-body">
        <div className="row">
          <div className="form-group col-5">
            <InputTextBox
              label={"Customer"}
              value={customerCode}
              required={true}
              disable={true}
            />
          </div>
          <div className="form-group col-fit">
            <CustomButton
              buttonHandler={buttonHandler}
              disable={disable}
              buttonRef={buttonRef}
              label={"Fetch"}
            />
          </div>
        </div>
      </div>

      {!isEmptyArray(dataList) ? (
        <PageBar
          loadFirst={loadFirst}
          loadNext={loadNext}
          loadPrevious={loadPrevious}
          loadLast={loadLast}
          page={page}
        />
      ) : null}
      {!isEmptyArray(dataList) ? (
        <ViewToggle
          listViewHandler={listViewHandler}
          gridViewHandler={gridViewHandler}
        />
      ) : null}
      {!isEmptyArray(dataList) ? (
        <div className="card-body">
          <div className="card-title">
            <h1>Inbound Order Details</h1>
          </div>

          <div className="list-wrap">
            {view == 2 ? (
              <CustomTable
                columns={Columns}
                data={dataList}
                isShowFullScreen={true}
              />
            ) : (
              <>
                {dataList.map((ln, idx) => {
                  return (
                    <div className="list-itm" key={idx}>
                      <div className="tb-flex">
                        <div className="table-itm-name">
                          <span className="_imp">{ln.code}</span> -{" "}
                          <span>{StatusConvertor(2, ln.orderStatus)} </span>
                          <span className="imp">
                            (
                            {toCommaSeperatedAmount(
                              ln.logisticOrderTotalQuantity
                            )}
                            )
                          </span>
                        </div>
                      </div>
                      <div className="tb-flex">
                        <div className="table-itm-name">
                          <span className="_imp">{ln.customerCode}</span>
                          <span>({ln.customerName}) </span>
                        </div>
                      </div>
                      <div className="tb-flex">
                        <div>{ln.orderDate}</div>
                        <div className="list-icon-wrap">
                          <div
                            className="icon-wrap"
                            onClick={() => PDFHandler(ln.code)}
                          >
                            <PDFICON />
                          </div>
                          <div
                            className="icon-wrap"
                            onClick={() => ExcelHandler(ln.code)}
                          >
                            <EXCELICON />
                          </div>
                          <div
                            className="icon-wrap"
                            onClick={() => MoreOptionHandler(ln.code)}
                          >
                            <MOREOPTIONICON />
                          </div>
                        </div>
                      </div>
                      <hr />
                    </div>
                  );
                })}
              </>
            )}
          </div>
        </div>
      ) : null}
      <InValidAccess isShow={isAccessible} clickHandler={onClose} />
    </>
  );
}
